import styled from 'styled-components';

export const CoursesSectionWrapper = styled.section`
  position: relative;
  margin-top: -280px;
`;

export const ContentWrapper = styled.div`
  border-radius: 5px;
  box-shadow: 0 16px 24px rgba(195, 203, 214, 0.24),
    0 0 16px rgba(195, 203, 214, 0.32);
`;

export const ContentIconWrapper = styled.div`
  border-radius: 5px;
`;
